// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__wfmJF","rows":"Monitor_rows__cm3S+","boxes":"Monitor_boxes__mxJoL","attitude":"Monitor_attitude__0wJ9x"};